import { render } from "./SupportToolTable.vue?vue&type=template&id=32c61596&scoped=true&ts=true"
import script from "./SupportToolTable.vue?vue&type=script&lang=ts"
export * from "./SupportToolTable.vue?vue&type=script&lang=ts"

import "./SupportToolTable.vue?vue&type=style&index=0&id=32c61596&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c61596"]])

export default __exports__